import md5 from 'js-md5'
import base from './pubilc.js'
import APPAPI from './httpPath.js'
import TransferAccount from './TransferAccount.js'

const API = APPAPI.APPAPI
const ITEM = base.storage()
let STATUS = base.LoginStatus()
const CONFIG = base.config()
let LOTTERYOPTION = base.lotterySildeOption()
let LOTTERYINIT = null
const USERINFO = {
  nickname: ''
}

function inputlineBtn() {
  TransferAccount()
}

// 判断是否是pc端
function IsPc() {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod']
  var flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

// 获取所有的彩种列表
function indexInit() {
  let index = {
    arror() {
      var mainContent = document.getElementById('main_content')
      var hoverBox = document.getElementById('hoverBox')
      var timer = null
      mainContent.addEventListener('mouseover', function () {
        clearTimeout(timer)
        hoverBox.style.display = 'block'
      }, false)
      mainContent.addEventListener('mouseout', function () {
        timer = setTimeout(function () {
          hoverBox.style.display = 'none'
        }, 200)
      }, false)
      hoverBox.addEventListener('mouseover', function () {
        clearTimeout(timer)
        this.style.display = 'block'
      }, false)
      hoverBox.addEventListener('mouseout', function () {
        var _this = this
        timer = setTimeout(function () {
          _this.style.display = 'none'
        }, 200)
      }, false)
      return this
    },
    lotteryPlayInit(obj, obj2, _this) {
      for (let i = 0; i < 3; i++) {
        let lotteryNum = LOTTERYINIT.getNum(3, 5)
        this.lotterySildeInitData += lotteryNum
        _this.lotteryOpenList.push({
          names: LOTTERYINIT.getName(8, 12),
          number: lotteryNum,
          lottery: LOTTERYINIT.getLottery()
        })
      }
      return this.tabFn(obj, obj2, _this)
    },
    lotterySildeInitTime: LOTTERYOPTION.time,
    lotterySildeInitData: 0,
    lotterySildeInitcycle: LOTTERYOPTION.isCycle,
    // 获取所有的彩种列表
//  lotteyList (_this) {
//    base.httpPost(_this, API.ROOTY + API.POOTYPATH.LOTTERY_LIST, function (result) {
//      if (result.code === 0) {
//        _this.lottery = result.data
//        this.$store.commit('setAllLotteryList', result.data)
//        LOTTERYINIT = base.lotteryinit(result.data)
////                  return false;
//      }
//    })
//    return this
//  },
    tabFn(obj, obj2, that) {
      let lotteryNum = LOTTERYINIT.getNum(3, 5)
      let NumLottery = 0
      let _this = this
      let InitData = '0000000'
      if (this.lotterySildeInitData > 99999999) this.lotterySildeInitData = 0
      this.lotterySildeInitData += lotteryNum
      InitData += this.lotterySildeInitData

      that.lotteryOpenList.push({
        names: LOTTERYINIT.getName(8, 12),
        number: lotteryNum,
        lottery: LOTTERYINIT.getLottery()
      })
      base.move(obj, {'top': -25})
      this.sildeInit(obj2, InitData.substring(InitData.length - 8), 0)
      return setTimeout(function () {
        try {
          obj.removeChild(obj.firstChild)
          obj.style.top = '0px'
          _this.tabFn(obj, obj2, that)
        } catch (e) {
          console.log(e)
        }
      }, this.lotterySildeInitTime)
    },
    sildeInit(obj, data, objIdx) {
      data += ''
      // console.log(data);
      if (!obj.length) {
        return false
      }
      if (objIdx >= 8) {
        return true
      }
      base.move(obj[objIdx], {'top': -data[objIdx] * 35}, null, LOTTERYOPTION.speedtime)
      return this.sildeInit(obj, data, ++objIdx)
    }
  }
  return index
}

function Prompt() {
  return base.Promptfn()
}

function loginInit() {
  let login = {
    getSlideCaptcha(_this, callback, fail){
      _this.$http.get(API.getSlideCaptcha
      ).then((res) => {
        if(res.status === 200)callback(res.data);
        else fail(res);
      });
    },
    checkSlideCaptcha(_this,x,y, callback, fail){
      let apis = API.checkSlideCaptcha + '?x=' + x+'&y='+y;
      _this.$http.get(apis
      ).then((res) => {
        if(res.status === 200)callback(res.data);
        else fail(res);
      });
    },
    testlogin(_this,callback) {
      var ssoParams = [API.ROOTS + API.ROOTSPATH.LOGIN, '?', 'cn=', _this.name,'&zdType=',2, '&password=', md5(_this.pass)]
      base.httpPost(_this, ssoParams.join(''), function (result) {
        let t = this
        if (result.code !== 0) {
          if(result.needCapchaCode){
            return callback();
          }
          if (result.code === 36 || result.code === 37) {
            this.captcha = ''
            this.isCaptcha = true
          }
          if (this.isCaptcha) {
            this.captcha = ''
          }
          if (result.code === 38) {
            this.captchasrc = API.ROOTS + API.ROOTSPATH.CAPTCHA + '?t=' + new Date()
            this.login_pass_error = '网络超时'
            return false
          }
          this.captchasrc = API.ROOTS + API.ROOTSPATH.CAPTCHA + '?t=' + new Date()
          this.login_pass_error = result.msg ? result.msg : result.message
          return false
        }
        ITEM.set('_pass', md5(this.pass))
        ITEM.set('_appid', result.user.sourceAppId)
        ITEM.set('_name', this.name)
        STATUS.set(t, 'loginStatus', 'true')
        ITEM.set('_isIndex', 'true')
        location.href = '/yx/home'
        return false
      })
    },
    // _this的指向为vue中的this
    login(_this) {
      // localStorage.setItem('_pass',md5(_this.pass))
      // localStorage.setItem('_appid',5)
      // localStorage.setItem('_name',_this.name)
      // STATUS.set(_this, 'loginStatus', 'true')
      // localStorage.setItem('_isIndex','true')
      // return false;

      var ssoParams = [API.ROOTS + API.ROOTSPATH.LOGIN, '?', 'cn=', _this.name,'&zdType=',2, '&password=', md5(_this.pass)]
      if (_this.captchasrc !== '') {
        ssoParams.push('&capchaCode=' + _this.captcha)
      }
      // ssoParams.push('&captchaTicket=' + _this.ticketdata);
      base.httpPost(_this, ssoParams.join(''), function (result) {
        let t = this
        if (result.code !== 0) {
          if (result.code === 36 || result.code === 37) {
            this.captcha = ''
            this.isCaptcha = true
          }
          if (this.isCaptcha) {
            this.captcha = ''
          }
          if (result.code === 38) {
            this.safetySrc = API.ROOTS + API.ROOTSPATH.CAPTCHA + '?t=' + new Date().getTime()
            this.login_pass_error = '网络超时'
            return false
          }
          this.safetySrc = API.ROOTS + API.ROOTSPATH.CAPTCHA + '?t=' + new Date().getTime()
          this.login_pass_error = result.msg ? result.msg : result.message
          return false
        }
        ITEM.set('_pass', md5(this.pass))
        ITEM.set('_appid', result.user.sourceAppId)
        ITEM.set('_name', this.name)
        STATUS.set(t, 'loginStatus', 'true')
        ITEM.set('_isIndex', 'true')
        sessionStorage.setItem('_isShowBox','true')
        location.href = '/yx/home';
        return false
      })
    },
    RefreshSrc(_this) {
      _this.captchasrc = API.ROOTS + API.ROOTSPATH.CAPTCHA + '?t=' + new Date().getTime()
    }
  }
  return login
}

function downloadInit() {
  return {
    browser() {
      base.browser(function () {
        ITEM.set('_browser', 'ios')
      }, function () {
        ITEM.set('_browser', 'android')
      }, function () {
        ITEM.set('_browser', 'web')
      })
    }
  }
}

// 获取所有的彩种
function userInit() {
  let user = {
    loginout(_this, isroter) {
      let ssoParams = [API.ROOTS + API.ROOTSPATH.LOGOUT, '?', 'cn=', ITEM.get('_name'), '&password=', ITEM.get('_pass'), '&appId=', ITEM.get('_appid')]
      base.httpPost(_this, ssoParams.join(''), function (result) {
        if (result.code === 0) {
          this.$store.commit('loginStatus', 'false')
          this.$emit('loginOutMsg', isroter)
        }
      })
//    ITEM.clear()
    },
    initlotteryBalance(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.USERLOOP, function (result) {
        if (result == -1) {
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
          return
        }
        if (result.code === 0) {
          // this.lotteryBalance = result.data.lotteryBalance;
          appConfig.hideBalance(result.data.lotteryBalance)
          // this.$store.commit('setLotteryBalance', result.data.lotteryBalance)
          //切换币种后的余额，应该也是获取上一次切换币种后的余额信息
          let coinObj = JSON.parse(localStorage.getItem('setItemCoin'));
          if (coinObj) {
            if (coinObj.code === 'RMB') {
              coinObj.balance = result.data.lotteryBalance;
            } else {
              coinObj.balance = result.data[coinObj.code]
            }
            localStorage.setItem('setItemCoin', JSON.stringify(coinObj));
            _this.$store.commit('setData', {key: 'defaultCoinData', value: coinObj});
          }else{
            coinObj = {name:'人民币',code:'RMB',id:1,balance:result.data.lotteryBalance,unit:'元'};
            localStorage.setItem('setItemCoin', JSON.stringify(coinObj));
            _this.$store.commit('setData', {key: 'defaultCoinData', value: coinObj});
          }
        }
      })
    },
    findMessageNum(_this) {
      base.httpPosts(_this, API.ROOTY + API.POOTYPATH.USER_MESSAGE_NUM, {page: 0, size: 10}, function (result) {
        if (result.message.includes('请求成功')) {
          let count = result.data.totalCount ? result.data.totalCount : 0
          _this.$store.commit('setMessageNum', count)
          appConfig.messageNum = count
        } else {
          console.log(result.data.message)
        }
//      console.log(result, 4343434343)
      })
    },
    userInit(_this) {
      let winUrl = location.href
      // ITEM.set('_isShowBox', true)

      ITEM.set('_navIndex', 0)
      ITEM.set('_bankCard', 0)
      if (winUrl.indexOf('/activity') !== -1) {
        ITEM.set('_navIndex', 7)
      }
      if (winUrl.indexOf('/userCenter#bandCard') !== -1) {
        ITEM.set('_bankCard', 1)
        return _this.$router.push('/userCenter')
      }
      if (winUrl.indexOf('/register') !== -1 && _this.$route.params.userid) {
        return _this.$router.push('/register/' + _this.$route.params.userid)
      }
      if (winUrl.indexOf('/download') !== -1 || winUrl.indexOf('/detection') !== -1) {
        return false
      }
      if (winUrl.indexOf('/entertainment') !== -1 || winUrl.indexOf('/detection') !== -1) {
        ITEM.set('_navIndex', 5)
      }
      if (winUrl.indexOf('/appdownload') !== -1) {
        return _this.$router.push('/appdownload')
      }
      if (winUrl.indexOf('/activity#type=mobile') !== -1) {
        return _this.$router.push('/activity')
      }
      if (winUrl.indexOf('/aboutUs') !== -1) {
        return false
      }
      if (winUrl.indexOf('/lottery') !== -1) {
        ITEM.set('_navIndex', 1)
      }
      // if (winUrl.indexOf('/index') !== -1) {
      //   ITEM.set('_isShowBox', false)
      // }
      if ((winUrl.indexOf('/login') !== -1 || winUrl[winUrl.length - 1] === '/') && STATUS.get(_this, 'isLogin') === 'true') {
        return _this.$router.push('/index')
      }
      if (STATUS.get(_this, 'isLogin') !== 'true') {
        return _this.$router.push('/login')
      }
      return this
    },
    lotteyList(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.LOTTERY_LIST, function (result) {
        if (result.code === 0) {
          _this.lottery = result.data
          appConfig.allLotterys = result.data
          this.dealLotteryDictionary(result.data)   //  官方和经典玩法对应的字典
          this.$store.commit('setAllLotteryList', result.data)
          LOTTERYINIT = base.lotteryinit(result.data)
        }
      })
      return this
    },
    // 获取用户的一些信息
    initUserInfo(_this) {
      let time = base.formatDate(new Date().getTime(), 'hh:mm:ss').split(':')[0]
      if (time < 4) {
        _this.$store.commit('setUserTime', '凌晨好')
      }
      if (time >= 4 && time < 8) {
        _this.$store.commit('setUserTime', '早上好')
      }
      if (time >= 8 && time < 11) {
        _this.$store.commit('setUserTime', '上午好')
      }
      if (time >= 11 && time < 14) {
        _this.$store.commit('setUserTime', '中午好')
      }
      if (time >= 14 && time < 18) {
        _this.$store.commit('setUserTime', '下午好')
      }
      if (time >= 18 && time < 22) {
        _this.$store.commit('setUserTime', '晚上好')
      }
      if (time >= 22 && time < 25) {
        _this.$store.commit('setUserTime', '午夜好')
      }
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_INFO, function (result) {
        if (result.code === 0) {
          if (!result.data.isLogin) {
            STATUS.set(this, 'loginStatus', 'false')
            location.href = '/'
            return false
          }
          this.nickname = result.data.main.nickname
          this.$store.commit('setBaseInfo', {
            nickName: this.nickname,
            lotteryBalance: this.lotteryBalance,
            userTime: this.userTime,
            mainAccount: result.data.main,
            lotteryAccount: result.data.lottery,
          });
          this.$store.commit('setLotteryBalance', result.data.lottery.availableBalance)
          this.$store.commit('setBlockedBalance', result.data.lottery.blockedBalance)
          this.istype = result.data.main.type
          this.lotterypoint = result.data.lottery.point
          ITEM.set('_userType', this.istype)
          this.userRegistertime = base.formatDate(result.data.main.registTime, 'yyyy-MM-dd hh:mm:ss')
          switch (result.data.main.type) {
            case 1:
              this.$store.commit('setUserType', '代理')
              break
            case 0:
              this.$store.commit('setUserType', '用户')
              break
            case 3:
              this.$store.commit('setUserType', '主管')
              break
            case 4:
              this.$store.commit('setUserType', '招商')
              break
            case 5:
              this.$store.commit('setUserType', '直属代理')
              break
            default:
              this.$store.commit('setUserType', '用户')
          }
        }
        return false
      })
    }
  }
  return user
}
let notice_list_title_old = '';
// 获取公告列表
function noticeInit() {
  let notice = {
    init(_this) {
      let url = API.ROOTY + API.POOTYPATH.NOTICE_LIST
      let url1 = API.ROOTY + API.POOTYPATH.LIST_MESSAGE + '?page=0&size=8'

      base.httpPost(_this, url, function (result) {
        result.data = Object.prototype.toString.call(result.data) === '[object Array]' ? result.data : []
        if (result.code === 0 && result.data.length >= 1) {
          var conData = result.data
          for (var i = 0, len = conData.length; i < len; i++) {
            conData[i].content = conData[i].content.replace(/&amp;nbsp;/g, '&nbsp;').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"')
            conData[i]['_time'] = conData[i].time
            conData[i].time = conData[i].time.split(' ')[0]
          }
          if(conData[0].title != notice_list_title_old){
            notice_list_title_old = conData[0].title;
            this.$store.commit('setPromptList', conData)
          }
          return true
        }
        this.$store.commit('setPromptList', [])
        return false
      })
    }
  }
  return notice
}

function userConterStatus() {
  return {
    setStatus: function (_this, key, value) {
      STATUS.set(_this, key, value)
    },
    getStatus: function (_this, key) {
      return STATUS.get(_this, key)
    }
  }
}

function userConter() {
  const sendAPI = {
    init(_this) {
      _this.nickname = ITEM.get('_nickname')
    },
    checkgrade(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_STATUS, function (result) {
        let grade = 0
        if (result.code === 0) {
          if (result.data.isBindWithdrawPassword) {
            grade += 33
          }
          if (result.data.isBindCard) {
            grade += 33
          }
          if (result.data.isBindWithdrawName) {
            grade += 33
          }
          if (grade <= 35) {
            this.gradeMsg.title = '低！'
            this.gradeMsg.num = 35
          }
          if (grade <= 70 && grade > 36) {
            this.gradeMsg.title = '中！'
            this.gradeMsg.num = 70
          }
          if (grade >= 90) {
            this.gradeMsg.title = '高！'
            this.gradeMsg.num = 100
          }
          // this.isbind = result.data;
          _this.$store.commit('SET_BIND_INFO', result.data);
          this.isCloseUserData = !!result.data.isBindWithdrawName
        }
      })
      return this
    },
    // 获取登录时间和登录ip
    checkClient(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_INFOALL, function (result) {
        if (result.code === 0) {
          this.loginTime = base.formatDate(result.data.account.loginTime, 'yyyy-MM-dd hh:mm:ss')
          this.clientIp = result.data.accountLoginLog.ip
        }
      })
      return this
    },
    setDefult(option) {
      this['sendUrl'] = API.ROOTY + API.POOTYPATH.SETCARD
      base.httpPosts(option._this, this.sendUrl, option.data, function (result) {
        return option.success(result)
      }, function (err) {
        return option.fail(err)
      })
    },
    gitcardinfo(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_CARDINFO, function (result) {
        if (result.code === 0) {
          this.nickNames = result.data.withdrawName
        }
      })
      return this
    },
    // 已经绑定的银行卡
    checkCard(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.LIST_CARD, function (result) {
        if (result.code === 0) {
          if (result.data.length > 0) {
            for (let i = 0, len = result.data.length; i < len; i++) {
              result.data[i].bankCardId = result.data[i].bankCardId.slice(-4)
            }
            this.bindBankList = result.data
            this.isSendData = false
          }
        }
      })
      return this
    },
    // 获取银行卡已经绑定过的昵称
    getNickname(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_BANK_NICKNAME, function (result) {
        if (result.code === 0) {
          // 将之前的昵称绑定到这张卡
          this.nickNames = result.data.withdrawName
        }
      })
      return this
    },
    // 获取银行列表
    loadBanks(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.LOADBANKS, function (result) {
        if (result.code === 0) {
          this.openBank = result.data.bankList[0].id
          this.bankList = result.data.bankList
        }
      })
      return this
    },
    sendUserData(_this, sendUrl) {

      base.httpPost(_this, sendUrl, function (result) {
        if (result.code === 0) {
          this.isCloseUserData = true
          sendAPI.checkCard(this).checkgrade(this)
          this.nickName = ''
          this.nickNameNote = '（提款的时候只能用真实姓名操作(不能填写字母、数字、特殊字符。)'
          this.openBank = this.bankList[0].id
          this.bankName = ''
          this.backNmaeNote = '填写支行名称遇到问题，请联系客服。'
          this.bankNumber = ''
          this.bankNumberNote = '由16或18或19位数字组成，请填写银行借记卡。'
          this.bankNumberAgain = ''
          this.bankNumberNoteAgain = '由16或18或19位数字组成，请填写银行借记卡。'
          this.fundsPwd = ''
          this.fundsPwdNote = '由6-12位字母和数字组成'
          for (let k in _this.isActive) {
            _this.isActive[k] = false
          }
          return true
        }
        this.receiveError = result.message
        return false
      })
      return this
    },
    sendResetPwd(_this, sendUrl) {
      base.httpPost(_this, sendUrl, function (result) {
        let that = this
        if (result.code === 0) {
          that.resetPwd = false
          Prompt()({
            message: "修改登录密码成功，2s后自动跳转至登录..."
          });
          this.$store.commit('loginStatus', 'false')
          setTimeout(function () {
            location.href = '/login'
          }, 2000)
          return true

//          _this.$store.commit('setChangeStatue', {
//			        flag: true,
//			        data: result.code
//			      })
        }
        this.resetPwdErroe = result.message
      })
      return this
    },
    // 已经绑定的钱包
    checkWallet(_this,cb) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.LIST_WALLET, function (result) {
        console.log(result)
        if (result.code === 0) {
          if (result.data.length > 0) {
            console.log(result.data,'checkWalletcheckWalletcheckWallet');
            this.bindWalletList = result.data
            this.isSendData = false;
          }
        }
        if (typeof cb =='function') {
          cb();
        }
      })
      return this
    },
    bindUserWallet(_this) {
        // /usdt/addWithdrawAddress
      let sendUrl = null
      sendUrl = [API.ROOTY + API.POOTYPATH.ADD_WALLET, '?', 'address=', _this.walletAdd,'&withdrawPassword=', md5(_this.fundsPwd1),].join('')

      base.httpPost(_this, sendUrl, function (result) {
        let that = this
        if (result.code === 0) {
          that.resetPwd = false
          _this.fundsPwd1 = '';
          _this.isCloseUserData3 = true;
          App.alert('success', '提示消息','添加钱包成功', 4000);
          userConter().checkWallet(_this);
          // Prompt()({
          //   message: "添加钱包成功"
          // });
        }
        _this.receiveError1 = result.message
      })
      //return this
      return true
    },
    // 获取用户登陆日志
    getLoginListInfo(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_LOGINDETAIL, function (result) {
        if (result.code === 0) {
          for (let i = 0, len = result.data.length; i < len; i++) {
            result.data[i].loginTime = base.formatDate(result.data[i].loginTime, 'yyyy-MM-dd hh:mm:ss')
          }
          // if (result.data.length > 5) {
          //     this.loginListInfo = result.data.slice(4);
          //     return;
          // }
          this.$store.commit('setLoginListInfo', result.data)
        }
      })
      return this
    },
//  sendResetFunds (_this, sendUrl) {
//    base.httpPost(_this, sendUrl, function (result) {
//      let that = this
//      if (result.code === 0) {
//        setTimeout(function () {
//          that.resetPwd = false
//        }, 1000)
//      }
//      this.resetPwdErroe = result.message
//    })
//    return this
//  },
    sendResetFunds(_this, sendUrl) {
      base.httpPost(_this, sendUrl, function (result) {
        let that = this
        if (result.code === 0) {
          that.resetPwd = false
          Prompt()({
            message: "修改资金密码成功"
          });
        }
        this.resetPwdErroe = result.message
      })
      return this
    },
    resetFundsPwd(_this) {
      let sendUrl = [API.ROOTY + API.POOTYPATH.RESET_FUNDSPASSWORD, '?', 'oldPassword=', md5(_this.oldPassword), '&newPassword=', md5(_this.rePassword)].join('')
      return this.sendResetFunds(_this, sendUrl)
    },
    bindUserInfo(_this) {
      let sendUrl = null
      if (_this.isSendData && !_this.nickNames) {
        sendUrl = [API.ROOTY + API.POOTYPATH.USER_DATA, '?', 'withdrawName=', _this.nickName, '&withdrawPassword=', md5(_this.fundsPwd), '&bankId=', _this.openBank, '&bankBranch=', _this.bankName, '&bankCardId=', _this.bankNumber].join('')
      } else {
        sendUrl = [API.ROOTY + API.POOTYPATH.ADD_BANK, '?', '&withdrawPassword=', md5(_this.fundsPwd), '&bankId=', _this.openBank, '&bankBranch=', _this.bankName, '&bankCardId=', _this.bankNumber].join('')
      }
      this.sendUserData(_this, sendUrl)
      return true
    },
    resetPwd(_this) {
      let sendUrl = [API.ROOTY + API.POOTYPATH.RESET_LOGINPASSWORD, '?', 'oldPassword=', md5(_this.oldPassword), '&newPassword=', md5(_this.rePassword)].join('')
      return this.sendResetPwd(_this, sendUrl)
    }
  }
  return sendAPI
}

// 用户注册
function registerInit() {
  let rg = {
    matchValue(value, _this, msg) {
      if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,15}$/.test(value) && /\d/gi.test(value)) {
        return true
      }
      _this.login_pass_error = msg
      return false
    },
    matchName(value, _this, msg) {
      if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,15}$/.test(value)) {
        if (!value) {
          _this.login_pass_error = msg
          return false
        }
        if (value[0].toString() !== '0') {
          return true
        }
        _this.login_pass_error = msg
        return false
      }
      _this.login_pass_error = msg
      return false
    },
    register(_this) {
      _this.login_pass_error = ''
      var sendData, ssoParams
      if (!this.matchName(_this.name, _this, '用户名由字母和数字组成，长度6-15位，不支持特殊字符！')) {
        return false
      }
      if (!this.matchValue(_this.pass, _this, '密码格式6-12位字母和数字组成, 不支持特殊字符！')) {
        return false
      }
      if (!_this.pass) {
        _this.login_pass_error = '请输入密码..'
        return false
      }
      if (_this.pass !== _this.passTo) {
        _this.login_pass_error = '重复密码输入不正确..'
        return false
      }
      // if (!_this.safety) {
      //   _this.login_pass_error = '请填写验证码..'
      //   return false
      // }
      if (!_this.serverTerms) {
        _this.login_pass_error = '请勾选《服务协议》..'
        return false
      }
      sendData = {
        name: _this.name,
        pwd: _this.pass,
        pid: 130,
        lnkid: 28,
        code: _this.safety,
        repeat: _this.passTo
      }
      ssoParams = [API.ROOTY + API.POOTYPATH.REGISTER, '?', 'parentId=', _this.parentId, '&link=', _this.links, '&name=', _this.name, '&pwd=', md5(_this.pass), '&confiemPwd=', md5(_this.passTo)]
      // ssoParams.push('&captchaTicket=' + _this.ticketdata)
      ssoParams.push('&yanzCode=' + _this.safety)
      // if (_this.captchasrc !== '') {
      //   ssoParams.push('&capchaCode=' + _this.captcha)
      // }
      base.httpPost(_this, ssoParams.join(''), function (result) {
        let _this = this
        if (result.code === 0) {
          if (!IsPc()) {
            Prompt()({
              idx: 'register',
              message: '注册成功，2s后自动跳转至登录...'
            })
            return setTimeout(function () {
              location.href = '/login.html'
            }, 2000)
          }

          this.$store.commit('loginStatus', 'false')
          this.iscloseFunds = true
          this.registerMsg = '注册成功';
          App.alert('success', '提示消息', '注册成功，将自动跳转至登录...', 2000);
          setTimeout(function () {
            _this.iscloseFunds = false
            _this.registerMsg = '';
            location.href = '/login';
          }, 2000)
          return true
        }
        this.safetySrc = API.ROOTY + API.POOTYPATH.CAPTCHA + '?t=' + new Date()
        this.login_pass_error = result.message
        return false
      })
      return this
    },
    initlink(_this) {
      let winUrl = location.href.split('register/')
      if (!winUrl[1]) {
        return _this.$router.push('/login')
      }
      var ssoParams = [API.ROOTY + API.POOTYPATH.USER_REGISTER, '?', 'link=', winUrl[1]]
      base.httpPost(_this, ssoParams.join(''), function (result) {
        if (result.code.toString() !== '0') {
          alert('链接参数无效.')
          let reg = /(iPhone|iPad|iPod|iOS|Android)/i
          reg.test(navigator.userAgent) ? location.href = '/login.html' : this.$router.push('/login')
          return true
        }
        this.parentId = result.data.parentId
        this.links = result.data.link
        return false
      })
      return this
    },
    RefreshSrc(_this) {
      _this.safetySrc = API.ROOTY + API.POOTYPATH.CAPTCHA + '?t=' + new Date().getTime();
    }

  }
  return rg
}

// 测速
function speedInit() {
  let speed = {
    init2(_this, startime) {
      console.log(appConfig, 'ininin');
      let odate = (new Date().getTime()) - startime;
      let re = []
      for (let [v, i] of new Map(appConfig.speedSrc.map((v, i) => [i, v]))) {
        re.push({
          src: i,
          time: odate,
          msg: appConfig.speedConfig[1][v],
          wid: appConfig.speedConfig[0][v]
        })
      }
      _this.$store.commit('setLineSpeedArr', {
        flag: true,
        data: re
      })
    }
  }
  return speed
}

function activityInit() {
  let activity = {
    activityDetails(btn, showobj, obj, initidx, isdoc) {
      let btns = document.getElementsByClassName(btn)
      let btnBoxs = document.getElementsByClassName(showobj)
      if (initidx) {
        btnBoxs[initidx].style.display = 'block'
        btns[initidx].zdblock = true
      }

      function clearBtnBoxs(obj, btns) {
        for (let i = 0, len = obj.length; i < len; i++) {
          btns[i].zdblock = false
          obj[i].style.display = 'none'
        }
      }

      function eventloop(e, btnBoxs, btns, _this) {
        if (e && e.stopPropagation) {
          e.stopPropagation()
        } else {
          window.event.cancelBubble = true
        }
        if (e.target.nodeName === obj) {
          return false
        }
        if (_this.zdblock) {
          btnBoxs[_this.index].style.display = 'none'
          _this.zdblock = false
          return false
        }
        clearBtnBoxs(btnBoxs, btns)
        btnBoxs[_this.index].style.display = 'block'
        _this.zdblock = true
        return true
      }

      for (let i = 0, len = btns.length; i < len; i++) {
        btns[i].index = i
        btns[i].addEventListener('click', function (e) {
          eventloop(e, btnBoxs, btns, this)
        }, false)
      }
      if (isdoc) return {btns, btnBoxs, clearBtnBoxs}
      document.addEventListener('click', function () {
        clearBtnBoxs(btnBoxs, btns)
      }, false)
      return {
        btns,
        btnBoxs
      }
    },
    playDetails(btn, showobj, obj) {
      let btns = document.getElementsByClassName(btn)
      let btnBoxs = document.getElementsByClassName(showobj)

      function clearBtnBoxs(obj, btns) {
        for (let i = 0, len = obj.length; i < len; i++) {
          btns[i].zdblock = false
          obj[i].style.display = 'none'
        }
      }

      function playDetailsEvent(e, btnBoxs, btns, _this) {
        if (e && e.stopPropagation) {
          e.stopPropagation()
        } else {
          window.event.cancelBubble = true
        }
        if (obj && e.target.nodeName === obj) {
          return false
        }

        clearBtnBoxs(btnBoxs, btns)
        btnBoxs[_this.index].style.display = 'block'
        return true
      }

      function playDetailsEve(e, btnBoxs, btns, _this) {
        if (e && e.stopPropagation) {
          e.stopPropagation()
        } else {
          window.event.cancelBubble = true
        }
        if (obj && e.target.nodeName === obj) {
          return false
        }

        btnBoxs[_this.index].style.display = 'none'
        return true
      }

      for (let i = 0, len = btns.length; i < len; i++) {
        btns[i].index = i
        btns[i].addEventListener('mouseover', function (e) {
          playDetailsEvent(e, btnBoxs, btns, this)
        }, false)
        btns[i].addEventListener('mouseout', function (e) {
          playDetailsEve(e, btnBoxs, btns, this)
        }, false)
      }
    },
    getbanlce(_this, str) {
      return base.httpPost(_this, API.ROOTY + API.POOTYPATH.THIRDAMOUNT + '?platformId=' + str, function (result) {
        if (result.code.toString() === '0') {
          this.account = result.data
        }
      })
    },
    opengames(_this, str) {
      return base.httpPost(_this, API.ROOTY + API.POOTYPATH.GAMEURL + '?platformId=' + str, function (result) {
        this.msgnotice = '进入游戏'
        if (result.code.toString() === '0') {
          window.open(result.data, '_blank')
        }
      })
    }
  }
  return activity
}

// 获取站内信
function stationNotice() {
  let notice = {
    listall: [],
    init(_this) {
      this.Dom = document.getElementById('noticeLength')
      this.loopNotice(_this)
    },
    getNotice(_this) {
      if (STATUS.get(_this, 'isLogin') !== 'true') {
        return false
      }
      let that = this
      return base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_NOTICE, function (result) {
        result.data = Object.prototype.toString.call(result.data) === '[object Array]' ? result.data : []
        this.$store.commit('setNoticeCount', result.data.length);
        if (result.code === 0 && result.data.length >= 1) {
          for (let i = 0, len = result.data.length; i < len; i++) {
            result.data[i].time = base.formatDate(result.data[i].time, 'hh:mm:ss')
            that.listall.push(result.data[i].id)
          }
          this.noticeList = result.data
          this.showNotice = true
          return false
        }
        this.noticeList = []
        this.showNotice = false
        return true
      })
    },
    loopNotice(_this) {
      if (STATUS.get(_this, 'isLogin') !== 'true') {
        return false
      }
      let that = this
      return setInterval(function () {
        that.getNotice(_this)
      }, 60000)
    },
    readyNotice(_this) {
      let that = this
      return base.httpPost(_this, API.ROOTY + API.POOTYPATH.USER_NOTICEREADY + '?ids=' + (this.listall.toString()), function (result) {
        if (result.code === 0) {
          that.getNotice(this)
        }
      })
    }
  }
  return notice
}

function StorageNotice() {
  return {
    _timer: null,
    _isStatus: false,
    noticeMove(_this) {
      return
      let t = this
      this._timer = setTimeout(function () {
        (this._isStatus && _this.NoticeMoveNum--) || _this.NoticeMoveNum++
        if (_this.NoticeMoveNum >= _this.promptList.length - 1) return this._isStatus = true, t.noticeMove(_this)
        if (_this.NoticeMoveNum <= 0) this._isStatus = false
        base.move(_this.$refs.notice, {'top': -35 * _this.NoticeMoveNum})
        return t.noticeMove(_this)
      }, _this.NoticeMoveTime)
    },
    clearTImer() {
      console.log('clearInterval')
      clearTimeout(this._timer)
    }
  }
}

// 获取第三方游戏相关内容
function thirdpartyGame() {
  return {
    getLinkUrl(_this, platformId) {
      // console.log('platformId:++'+platformId)
      let str = platformId === 6 ? '&subGame=sport' : '' // 如果是体育，则增加参数‘subGame=sport’
      let arr = [API.ROOTY + API.POOTYPATH.LOGIN_URL, '?',
        'platformId=', platformId, str
      ]
      base.httpPost(_this, arr.join(''), function (res) {
        if (res) {
          if (res.code == '0') {
            _this.clickIndex = -1
            this.gameUrl = res.data
            console.log(this.gameUrl);

            return true
          } else if (String(res.message).indexOf('关闭') > -1) {
            return Prompt()({
              idx: 'boxwarps',
              message: '敬请期待'
            })
          } else {
            return Prompt()({
              idx: 'boxwarps',
              message: res.message
            })
          }
        }
      })
    },
    // 天彩vr
    getTcLink(_this) {
      let arr = [API.ROOTY + API.POOTYPATH.LOGIN_URL, '?',
        '&platformId=14'
      ];
      base.httpPost(_this, arr.join(''), function (res) {
        if (res.code === 0) {
          _this.tcLink = res.data;
          appConfig.showTcVr = res.data;
        } else {
          _this.tcLink = '';
        }
      })
    },
    // 得到余额
    getBalances(_this, val) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.THIRD_PARTY_BALANCE, function (res) {
        if (res.code === 0) {
          let arr = res.data
          if (arr && arr.length) {
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].platformId === val) {
                this.walletBalance = arr[i].balance
                break
              }
            }
            this.thirdMoney = res;
            this.$store.commit('setThirdGameBalances', arr)
          }
        }
      })
    },
    // 一次性得到所有的彩种余额
    getAllBalances(_this) {
      base.httpPost(_this, API.ROOTY + API.POOTYPATH.THIRD_PARTY_BALANCE, function (res) {
        if (res.code == 0) {
          let arr = res.data
          if (arr && arr.length) {
            this.$store.commit('setThirdGameBalances', arr)
          }
        }
      })
    }
  }
}

export {
  indexInit,
  loginInit,
  userInit,
  IsPc,
  userConter,
  registerInit,
  speedInit,
  activityInit,
  downloadInit,
  noticeInit,
  stationNotice,
  Prompt,
  inputlineBtn,
  userConterStatus,
  StorageNotice,
  thirdpartyGame
}



// WEBPACK FOOTER //
// src/js/index.js